import React from "react";

export default function Base() {
	return <><rect fill="none" x="15" y="15" width="70" height="70"/><path d="M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"/></>
}